import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr';
import esLocale from 'date-fns/locale/es';
import itLocale from 'date-fns/locale/it';
import ptLocale from 'date-fns/locale/pt';
import nlLocale from 'date-fns/locale/nl';
import daLocale from 'date-fns/locale/da';
import svLocale from 'date-fns/locale/sv';
import plLocale from 'date-fns/locale/pl';
import ruLocale from 'date-fns/locale/ru';
import jaLocale from 'date-fns/locale/ja';
import zhCNLocale from 'date-fns/locale/zh-CN';

// Map language codes to date-fns locale objects
export const getLocaleFromLanguage = (languageCode) => {
  switch (languageCode) {
    case 'de':
      return deLocale;
    case 'en':
      return enLocale;
    case 'fr':
      return frLocale;
    case 'es':
      return esLocale;
    case 'it':
      return itLocale;
    case 'pt':
      return ptLocale;
    case 'nl':
      return nlLocale;
    case 'da':
      return daLocale;
    case 'sv':
      return svLocale;
    case 'pl':
      return plLocale;
    case 'ru':
      return ruLocale;
    case 'ja':
      return jaLocale;
    case 'zh':
      return zhCNLocale;
    default:
      return enLocale;
  }
};
